import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

  $(window).on("load", function () {

    ScrollTrigger.create({
      trigger: '.topService',
      start: 'top 50px',
      end: 'bottom 50px',
      // markers: true,
      toggleClass: {
        targets: ".navFixed.is-top,.navFixed-navBt.is-top",
        className: "is-blk",
      },
      // once: true,
    });

    ScrollTrigger.create({
      trigger: '.whoCompany',
      start: 'top 50px',
      end: 'bottom 50px',
      // markers: true,
      toggleClass: {
        targets: ".navFixed.is-who,.navFixed-navBt.is-who",
        className: "is-blk",
      },
      // once: true,
    });

    ScrollTrigger.create({
      trigger: '.cmn-contact',
      start: 'top 50px',
      end: 'bottom 50px',
      // markers: true,
      toggleClass: {
        targets: ".navFixed,.navFixed-navBt",
        className: "is-blk",
      },
      // once: true,
    });

    ScrollTrigger.create({
      trigger: '.topService-ttlBox',
      start: 'top 50%',
      end: 'bottom 50px',
      // markers: true,
      toggleClass: {
        targets: ".topService-ttlBox-strong",
        className: "is-animeOn",
      },
      once: true,
    });

    gsap.to('.js-txtAnime span', 1, {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: '.whoMission-txtArea',
        start: 'top 50%',
        end: 'bottom 50px',
        // markers: true,
      },
      stagger: {
        from: "random",
        amount: 1.5,
        // each: 0.5,//要素が１つずつ0.5秒遅れて再生
      },
    });

    gsap.to('.js-txtAnime02 span', 1, {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: '.whoVision-txtArea',
        start: 'top 50%',
        end: 'bottom 50px',
        // markers: true,
      },
      stagger: {
        from: "random",
        amount: 1.5,
        // each: 0.5,//要素が１つずつ0.5秒遅れて再生
      }
    });

    gsap.to('.js-txtAnime03 span', 1, {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: '.whoValue',
        start: 'top 50%',
        end: 'bottom 50px',
        // markers: true,
      },
      stagger: {
        from: "random",
        amount: 1.5,
        // each: 0.5,//要素が１つずつ0.5秒遅れて再生
      },
    });

    gsap.to('.js-txtAnime04 span', 1, {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: '.recruit__ttl',
        start: 'top 50%',
        end: 'bottom 50px',
        // markers: true,
      },
      stagger: {
        from: "random",
        amount: 1.5,
        // each: 0.5,//要素が１つずつ0.5秒遅れて再生
      },
    });

});

ScrollTrigger.matchMedia({
  "(min-width: 769px)": function () {

    $(window).on("load", function () {

      ScrollTrigger.create({
        trigger: '.topMv',
        ease: "power1",
        start: 'bottom top+=50px',
        endTrigger : '.body',
        end: 'bottom top',
        // markers: true,
        toggleClass: {
          targets: ".navFixed.is-top",
          className: "is-on",
        },
        // once: true,
      });
  
      ScrollTrigger.create({
        trigger: '.topPurpose',
        start: 'top 50px',
        end: 'bottom 50px',
        // markers: true,
        toggleClass: {
          targets: ".js-navFixed01",
          className: "is-on",
        },
        // once: true,
      });
  
      ScrollTrigger.create({
        trigger: '.topService',
        start: 'top 50px',
        end: 'bottom 50px',
        // markers: true,
        toggleClass: {
          targets: ".js-navFixed02",
          className: "is-on",
        },
        // once: true,
      });
  
      ScrollTrigger.create({
        trigger: '.topNews',
        start: 'top 50px',
        end: 'bottom 50px',
        // markers: true,
        toggleClass: {
          targets: ".js-navFixed03",
          className: "is-on",
        },
        // once: true,
      });
  
      ScrollTrigger.create({
        trigger: '.topRecruit',
        start: 'top 50px',
        end: 'bottom 50px',
        // markers: true,
        toggleClass: {
          targets: ".js-navFixed04",
          className: "is-on",
        },
        // once: true,
      });
  
      ScrollTrigger.create({
        trigger: '.cmn-contact',
        start: 'top 50px',
        end: 'bottom 50px',
        // markers: true,
        toggleClass: {
          targets: ".js-navFixed05",
          className: "is-on",
        },
        // once: true,
      });

      ScrollTrigger.create({
        trigger: '.topPurpose',
        start: 'top 50%',
        end: 'bottom 50px',
        // markers: true,
        toggleClass: {
          targets: ".topPurpose-txtBox-ttl",
          className: "is-animeOn",
        },
        once: true,
      });

      gsap.to('.js-txtAnime span', 1, {
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.whoMission-txtArea',
          start: 'top 50%',
          end: 'bottom 50px',
          // markers: true,
        },
        stagger: {
          from: "random",
          amount: 1.5,
          // each: 0.5,//要素が１つずつ0.5秒遅れて再生
        },
      });
  
      gsap.to('.js-txtAnime02 span', 1, {
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.whoVision-txtArea',
          start: 'top 50%',
          end: 'bottom 50px',
          // markers: true,
        },
        stagger: {
          from: "random",
          amount: 1.5,
          // each: 0.5,//要素が１つずつ0.5秒遅れて再生
        },
      });
  
      gsap.to('.js-txtAnime03 span', 1, {
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.whoValue',
          start: 'top 50%',
          end: 'bottom 50px',
          // markers: true,
        },
        stagger: {
          from: "random",
          amount: 1.5,
          // each: 0.5,//要素が１つずつ0.5秒遅れて再生
        },
      });
  
      gsap.to('.js-txtAnime04 span', 1, {
        autoAlpha: 1,
        scrollTrigger: {
          trigger: '.recruit__ttl',
          start: 'top 50%',
          end: 'bottom 50px',
          // markers: true,
        },
        stagger: {
          from: "random",
          amount: 1.5,
          // each: 0.5,//要素が１つずつ0.5秒遅れて再生
        },
      });

  });
  },
});


ScrollTrigger.matchMedia({
  "(max-width: 768px)": function () {
    $(window).on("load", function () {

    ScrollTrigger.create({
      trigger: '.topPurpose',
      start: 'top 20%',
      end: 'bottom 50px',
      // markers: true,
      toggleClass: {
        targets: ".topPurpose-txtBox-ttl",
        className: "is-animeOn",
      },
      once: true,
    });

  });

  },
});
